import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import React , {Component} from 'react';
import Modal from 'react-modal';
import firebase from 'firebase';
import Alert from 'react-s-alert';


const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    transform             : 'translate(-50%, -50%)',
	width                 : '450px'
	
  }
};

const database=firebase.database();

class ModalTarifasVehiculos extends Component{
	
	constructor(props){
		
		super(props);
		this.state={
			isActive:false
			
		}
		
		this.tarifasRef=database.ref().child('Tarifas_Vehiculos');
		this.toggleModal=this.toggleModal.bind(this);
		this.handleSubmit=this.handleSubmit.bind(this);

		
	
	}
	
	
	handleSubmit(event){
		
		let cinco=this.cinco.value;
		let diez=this.diez.value;
		let quince=this.quince.value;
		let masquince=this.masquince.value;
		let tipo=this.tipo_vehiculo.value;
		
		
		
		
		database.ref().child('Tarifas_Vehiculos').orderByKey().equalTo(tipo).once("value").then(snapshot=>{
			
			if(!snapshot.exists()){
				
				this.tarifasRef.child(tipo).update({
			
					d_5km:cinco,
					d_10km:diez,
					d_15km:quince,
					mas_15km:masquince
					
				})
				
				Alert.success('Datos guardados correctamente', {
					effect: 'genie',
					position: 'bottom-right',
					timeout:2000			
				});
				
				this.toggleModal();

			}
			else{
				
				Alert.warning('La tarifa que desea establecer ya existe', {
					effect: 'genie',
					position: 'bottom-right',
					timeout:2000			
				});
				
				
			}
			
			
		});
		
		
		
		
		event.preventDefault();
		
	}
	
	
	toggleModal(){
		
		this.setState({
			
			isActive:!this.state.isActive
			
		})
		
	}
	
	
	
	render(){
		
		return(
		
			<div className="modal_tarifas">
				<button className="btn btn-primary" onClick={this.toggleModal}><span className="glyphicon glyphicon-plus"> </span> Nuevo</button>
				
				<Modal isOpen={this.state.isActive} onRequestClose={this.toggleModalUpdate}  style={customStyles}>
						
					
						<form method="POST" action="" onSubmit={this.handleSubmit}>
						
						
							<h3>Modificar Tarifa</h3>
							<hr/>
							<div className="form-group">
								<label htmlFor="">Tipo de Vehiculo</label>
								<select className="form-control"								
								defaultValue={this.state.tipo_vehiculo}
								ref={input => {this.tipo_vehiculo=input;}}	
								>
									<option>Taxi</option>
									<option>Privado</option>
									<option>Microbus</option>
								</select>
							</div>
							
							<div className="form-group">
								<label htmlFor="cincoKilometros">5km</label>
								<input type="text" className="form-control"
								 ref={input => {this.cinco=input;}}	
								 placeholder="Costo 5km" required
								 autoComplete="off"
								/>								
							</div>
							<div className="form-group">
								<label htmlFor="cincoKilometros">10km</label>
								<input type="text" className="form-control"
								 ref={input => {this.diez=input;}}	
								 placeholder="Costo 10km" required
								 autoComplete="off"
								/>								
							</div>
							<div className="form-group">
								<label htmlFor="cincoKilometros">15km</label>
								<input type="text" className="form-control"
								 ref={input => {this.quince=input;}}	
								 placeholder="Costo 15km" required
								 autoComplete="off"
								/>								
							</div>
							<div className="form-group">
								<label htmlFor="cincoKilometros">Mayor a 15Km</label>
								<input type="text" className="form-control"
								 ref={input => {this.masquince=input;}}	
								 placeholder="Costo mass15km" required
								 autoComplete="off"
								/>								
							</div>
							<hr/>
							<button className="btn btn-primary buttons" type="submit" >Guardar</button>
						</form>
							<button className="btn btn-default buttons btnmargin" onClick={this.toggleModal}>Cerrar</button>
						
			</Modal> 
				
			</div>
		)
		
		
	}
	
	
}
export default ModalTarifasVehiculos;


// WEBPACK FOOTER //
// ./src/Components/Tarifas/ModalTarifasVehiculos.js